export const onload = document.querySelector('.js-on-loading'),
  body = document.body,
  navigation_effects = document.querySelectorAll('.js-navigation-effect'),
  all_navigation_buttons = document.querySelectorAll('.js-navigation'),
  copyButtons = document.querySelectorAll('.js-copy-button'),
  statuses = document.querySelectorAll('.js-status'),
  statusCursor = document.querySelector('.js-status-cursor'),
  menu = document.querySelector('.js-menu'),
  menu_navigation = menu.querySelector('.js-menu-navigation'),
  menu_navigation_buttons = menu_navigation.querySelectorAll('.js-navigation'),
  menu_button = document.querySelector('.js-menu-button'),
  menu_blackout = document.querySelector('.js-menu-blackout'),
  header_bg = document.querySelector('.js-header-bg'),
  logo = document.querySelector('.js-header-logo'),
  footer = document.querySelector('.js-footer'),
  footer_socials = document.querySelector('.js-footer-socials'),
  footer_messengers = document.querySelector('.js-footer-messengers'),
  footer_bg = document.querySelector('.js-footer-bg'),
  hello_screen = document.querySelector('.js-hello-section'),
  about = document.querySelector('.js-about-section'),
  about_title = document.querySelector('.js-about-title'),
  about_text = document.querySelector('.js-about-text'),
  resume = document.querySelector('.js-resume-section'),
  resume_title = resume.querySelector('.js-resume-title'),
  resume_list = resume.querySelector('.js-resume-list'),
  softSkills = document.querySelectorAll('.js-soft-skills-section'),
  softSkills_title = document.querySelectorAll('.js-soft-skills-title'),
  softSkills_list = document.querySelectorAll('.js-soft-skills-list'),
  softSkills_list_items = document.querySelectorAll('.js-soft-skills-list'),
  softSkills_image = document.querySelectorAll('.js-soft-skills-image'),
  hardSkills = document.querySelectorAll('.js-hard-skills-section'),
  othersSkills = document.querySelector('.js-others-skills-section'),
  othersSkills_title = document.querySelector('.js-others-skills-title'),
  othersSkills_list = document.querySelector('.js-others-skills-list'),
  contacts = document.querySelector('.js-contacts-section'),
  contacts_title = document.querySelector('.js-contacts-title'),
  contacts_email = document.querySelector('.js-contacts-email'),
  contacts_number = document.querySelector('.js-contacts-number');
